import { TAB_SHOW } from '../../../../common/tabs/tabs.constants';
import { IDS } from './pnp-approval-workflow.constants';
import { deleteSettingsApprovalWorkflow, getSettingsApprovalWorkflowDetails, getSettingsApprovalWorkflow } from './pnp-approval-workflow.actions';
import { getSettingsApprovalWorkflowCategories } from '../pnp-settings.actions';
import { PNP_SETTINGS_APPROVAL_WORKFLOW_RESET } from '../pnp-settings.actions.types';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpSettingsApprovalWorkflow = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, DocumentManager , Notifier) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpSettingsApprovalWorkflow: policies.pnpSettingsApprovalWorkflow
            }), {
                getSettingsApprovalWorkflowDetails,
                deleteSettingsApprovalWorkflow,
                getSettingsApprovalWorkflowCategories,
                getSettingsApprovalWorkflow
            })(this);

            this.getSettingsApprovalWorkflowCategories();
        }

        this.onSelect = ({ item }) => {
            this.getSettingsApprovalWorkflowDetails(item.id, item.documentGroupUUID).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: IDS.app_policies_settings_approval_workflows_manage,
                    state: [IDS.app_policies_settings_approval_workflows_manage_details],
                    stateParams: { id: item.daw_id }
                });
            });
        };

        this.onRemove = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .textContent('The selected approval workflow will be archived. Do you want to continue ?')
                .ariaLabel('Archive document approval workflow')
                .ok('Yes')
                .cancel('No');
            this.dialog = $mdDialog.show(confirm).then(() => {
                Notifier.success('Approval workflow has been successfully archived.');
                this.deleteSettingsApprovalWorkflow(item.id, item.documentGroupUUID);
            }, angular.noop);
        };


        this.onReset = (event) => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'pnpSettingsApprovalWorkflowFilterForm');
            $ngRedux.dispatch({
                type: PNP_SETTINGS_APPROVAL_WORKFLOW_RESET,
                id: IDS.pnpSettingsApprovalWorkflow
            });
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
        }
    },
    template: `
        <pnp-settings-approval-workflow-grid
            on-select="$ctrl.onSelect($event)" 
            on-remove="$ctrl.onRemove($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-settings-approval-workflow-grid>
    `
};
